var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H16.25L22 5.75V24C22 25.1046 21.1046 26 20 26H4C2.89543 26 2 25.1046 2 24V2C2 0.895431 2.89543 0 4 0Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0V5.75H22L16.25 0Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 18,
    height: 7,
    rx: 0.8,
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 19V15.05H4.58C4.9 15.05 5.17 15.11 5.39 15.23C5.61 15.35 5.78 15.51 5.89 15.72C6 15.92 6.06 16.15 6.06 16.41C6.06 16.67 6 16.9 5.89 17.1C5.78 17.3 5.61 17.46 5.39 17.58C5.17 17.69 4.89 17.75 4.57 17.75H3.84V17.03H4.43C4.61 17.03 4.76 17 4.87 16.94C4.99 16.88 5.07 16.81 5.12 16.72C5.18 16.63 5.2 16.52 5.2 16.41C5.2 16.29 5.18 16.19 5.12 16.1C5.07 16 4.99 15.93 4.87 15.88C4.76 15.82 4.61 15.79 4.42 15.79H3.95V19H3.1Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02 19V15.05H8.4C8.8 15.05 9.14 15.13 9.42 15.28C9.7 15.44 9.92 15.66 10.07 15.96C10.22 16.25 10.3 16.6 10.3 17.02C10.3 17.43 10.22 17.79 10.07 18.08C9.92 18.38 9.7 18.61 9.41 18.76C9.12 18.92 8.78 19 8.37 19H7.02ZM7.87 18.26H8.33C8.58 18.26 8.79 18.22 8.95 18.13C9.11 18.04 9.23 17.9 9.31 17.72C9.39 17.54 9.43 17.3 9.43 17.02C9.43 16.74 9.39 16.51 9.31 16.33C9.23 16.14 9.11 16.01 8.95 15.92C8.8 15.83 8.59 15.79 8.35 15.79H7.87V18.26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 19V15.05H13.95V15.79H12.17V16.69H13.78V17.43H12.17V19H11.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.eddf75b2dafbf0c59dd9489f8337300e.svg";
export { ForwardRef as ReactComponent };